import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.less']
})
export class HelpComponent implements OnInit {

  keyword: string;

  constructor() { }
  tab;
  ngOnInit() {
    this.tab = 'relay';
  }

  searchWiki(keyword) {
    window.open('https://wiki.corp.adobe.com/dosearchsite.action?queryString=' + keyword);
  }
}
